module.exports = __webpack_public_path__ + "img/FLDCOMP.ac5c0f89.svg";